import { lastNameValidationRule, phoneValidationRule } from '@shared/entity';
import { Stack, Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { CreateVisitType } from '../../visits/entity';
import TextField from '@shared/components/TextField';
import Switch from '@shared/components/Switch/SwitchButton';
import { useIntlTranslations } from '@libs/intl/intl.hooks';
import PhonePrefixAutocomplete from '@shared/components/phone-prefix-autocomplete';
import { usePhoneDuplicateValidator } from '../validators';

export const NewClientForm = () => {
  const { t } = useIntlTranslations();
  const { control } = useFormContext<CreateVisitType>();
  const depositRequired = useWatch({ control, name: 'depositRequired' });
  const validatePhoneUnique = usePhoneDuplicateValidator();

  return (
    <Stack spacing={1} padding={1}>
      <TextField
        fieldPath="firstName"
        control={control}
        label={t('addVisitForm.firstName')}
        type="text"
        fullWidth
      />
      <TextField
        fieldPath="lastName"
        control={control}
        label={t('addVisitForm.lastName')}
        type="text"
        fullWidth
        rules={lastNameValidationRule}
      />
      <Stack direction="row" spacing={1} alignItems="flex-start">
        <PhonePrefixAutocomplete control={control} name="phonePrefix" />
        <TextField
          fieldPath="phone"
          control={control}
          label={t('addVisitForm.phone')}
          type="tel"
          fullWidth
          rules={{
            ...phoneValidationRule,
            validate: {
              phoneFormat: phoneValidationRule.validate,
              phoneUnique: validatePhoneUnique,
            },
          }}
        />
      </Stack>
      <TextField
        fieldPath="clientNote"
        control={control}
        label={t('addVisitForm.clientInfo')}
        type="text"
        multiline
        minRows={2}
        maxRows={10}
        fullWidth
      />
      <Stack
        direction="row"
        alignItems="center"
        bgcolor="#dddddd"
        paddingX="1rem"
        borderRadius="10px"
        boxShadow="0px 1px 7px 0px rgba(0,0,0,0.12)"
      >
        <Typography fontWeight={600} color="secondary.main">
          {t('addVisitForm.depositRequiredSwitch')}
        </Typography>
        <Switch control={control} fieldPath="depositRequired" />
      </Stack>
      {depositRequired && (
        <TextField
          fieldPath="deposit"
          label={t('addVisitForm.depositAmount')}
          type="number"
          fullWidth
          control={control}
          required
        />
      )}
    </Stack>
  );
};
